import React from 'react';

export default function PaperHeader() {
  return null;
}
